import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'

import Meta from '../components/Meta'

export const PrivacyPolicyScreen = ({match, history}) => {

    
    const dispatch = useDispatch()

    

    useEffect(() => {
       

    }, [])





    return(

        <div style={{padding:'20px'}}>
        
        <Meta title='Laeyerz Privacy Policy' description='Privacy Policy for Laeyerz' />
<h1>PRIVACY POLICY </h1>

<h5>Effective date: May 01, 2025</h5>

<ListGroup style={{border:'None'}}>

<ListGroup.Item style={{border:'None'}}>
Pixagan Technologies Private Limited (“Company”, “We”, “Our” or “Us”) operates laeyerz.com (the “Site”), which serves as the landing page and documentation portal for Laeyerz, an open‑source Python library for building AI workflows and agents (the “Services”).
You must be at least 18 years old to access the Site. If you are under 18 years of age, your usage of the Site shall be under the consent and supervision of a parent or legal guardian. By your continued access or use of the Site, you signify your agreement to be legally bound by this Privacy Policy and the Terms. If you do not agree, please stop using the Services.
We collect limited information necessary to operate a documentation website and improve the developer experience. Any capitalized term used but not defined in this Privacy Policy shall have the meaning attributed to it in the Terms.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>LEGAL BASIS:</h5>
This Privacy Policy (“Privacy Policy") is meant to help the Users understand what information we collect, why we collect it, what information we disclose and how the Users can update, manage, export, and delete their information. It shall be read with the terms and conditions available at <Link to='/terms-and-conditions'>Terms and Conditions</Link> (“Terms”) and in compliance with the following:
<ul>
    <li>
The Information Technology Act, 2000 and rules thereunder;
</li>
<li>
The Information Technology (Reasonable Security Practices and Procedures and Personal Information) Rules, 2011 (the “IT Rules”); and
</li>
<li>
The Information Technology (Intermediaries Guidelines) Rules, 2011.
</li>
</ul>
This Privacy Policy and the Terms shall be governed by and construed in accordance with the laws of India which are not in conflict with each other. Any disputes arising out of or in connection with this Privacy Policy shall be subject to the exclusive jurisdiction of the competent courts of Kochi, Kerala, India.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>CONSENT:</h5>
The Users will be deemed to have read, understood and agreed to the terms as provided in this Privacy Policy. By granting their assent to this Privacy Policy, the Users provide consent to such use, collection and disclosure of Personal Information as prescribed in this Privacy Policy.
We reserve the right to update or change our Privacy Policy at any time and the Users should check this Privacy Policy periodically. To inform You of any material change as regards the manner in which We collect or process your information, including changes to this Privacy Policy, our updated Privacy Policy will be posted by Us on the Site, indicating the date on which the Privacy Policy was updated at the top of the page. Continued use of the Service after we post modifications will constitute acknowledgment and consent to the updated Privacy Policy. Users can, by sending an email to pixagan@gmail.com, inquire whether the Company is in possession of their personal data, and they may also require the Company to delete and destroy such information, upon request.
In the event the Services are used on behalf of any other individual, or on behalf of any entity, the Users represent that they are authorised to accept this Privacy Policy and share such data as required on behalf of such person or entity.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>INFORMATION COLLECTED:</h5>
All information collected by the Company is with the Users’ consent where required by law. We collect limited information necessary to operate the Site and improve the documentation experience:
<ul>
    <li>
Information You provide if You contact Us (such as email address and message content).
    </li>
    <li>
Usage and device information collected automatically as You navigate the Site, which may include IP address, device type, browser type and language, operating system, pages viewed, referring/exit pages, time zone, and timestamps.
    </li>
    <li>
Information collected through cookies, local storage, web beacons, UTM parameters, tracking pixels, and similar technologies for functionality and analytics.
    </li>
</ul>
We do not collect payment information on the Site and do not require account registration to view documentation.
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>USE OF THE INFORMATION COLLECTED:</h5>
We collect and use information for the following purposes:
<ul>
    <li>
To operate, maintain, and improve the Site and documentation experience;
</li>
<li>
To respond to inquiries and provide support;
</li>
<li>
To analyze Site usage and performance and develop new features or documentation;
</li>
<li>
To personalize the Services (for example, saving UI preferences);
</li>
<li>
To protect the security and integrity of the Services;
</li>
<li>
To comply with applicable laws, rules, and regulations; and
</li>
<li>
To create aggregated, de‑identified analytics to understand trends and improve developer experience.
</li>
<li>
In any other way consistent with this Privacy Policy and to support the above activities.
Additionally,
</li>
<li>
We reserve the right to use or disclose your Personal Information in response to any statutory or legal requirements in order to protect Our rights, the rights of our other Users, data processors and any other person or property.
</li>
<li>
Finally, We will use or disclose your Personal Information if We believe it is necessary to share information in order to investigate, prevent, or take action regarding illegal activities, suspected fraud, situations involving potential threats to the physical safety of any person or property, violations of the Platform’s other policies, or as otherwise required by law when responding to subpoenas, court orders and other legal processes.
</li>
</ul>
</ListGroup.Item>


<ListGroup.Item style={{border:'None'}}>
<h5>DATA PROTECTION:</h5>
The security of Personal Information is important and We have implemented commercially acceptable means to protect the same. However, remember that no method of transmission over the internet, or method of electronic storage, is 100% secure and We cannot guarantee its absolute security. We have implemented best industry practices and security policies, rules and technical measures to protect the data including Personal Information that is under the Company’s control from unauthorised access, improper use or disclosure, unauthorised modification and unlawful destruction or accidental loss. However, for any data loss or theft due to unauthorized access to the User’s electronic devices through which the User avails the Services, We shall not be held liable for any loss whatsoever incurred by the User. In the event, Our partners and third parties distribute Personal Information outside the scope of Our agreement with such partners or third parties, the Company cannot be held liable for the confidentiality. Further, in case breach of security or actions including without limitation, computer hacking, unauthorized access to computer data and storage device, computer crashes etc., you agree that the Company will shall not be held responsible in any manner. 
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>SHARING OF PERSONAL INFORMATION:</h5>
The Company may share Personal Information with third‑party service providers (“data processors”) who perform processing activities on Our behalf, such as hosting, analytics, and content delivery. We do not permit these providers to use Personal Information for their own purposes without Your consent. Our third‑party processors may include, for example, analytics providers such as Google Analytics and platforms that host or deliver Site assets. We do not sell Your Personal Information.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>THIRD PARTY DISCLAIMER:</h5>
The Site may contain links to other websites. Please note that when Users click on one of these links, they are entering another website over which We have no control and for which We shall bear no responsibility. Often these websites require the User to enter their Personal Information. We encourage Users to read the terms of use and privacy policies of all such websites as their policies may differ from Our Privacy Policy. Users agree that We shall not be liable for any breach of privacy or loss incurred by their use of such websites or services. The inclusions or exclusions are not suggestive of any endorsement by the Company of the website or contents of the website. Users may visit any third party website linked to the Site at their own risk.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>RIGHTS OF THE USERS:</h5>
As a User, the Company grants You complete control of the information collected. The rights pertaining thereto are enumerated below:
<ul>
    <li>
The right to access, update or delete the information We have on the User. This can be done through the User’s account settings available on the Platform.
</li>
<li>
The right of rectification. Users have the right to have their information rectified if that information is inaccurate or incomplete.
</li>
<li>
The right to object and restrict. Users can object and restrict to the processing of their Personal Information. This may however, interfere with the provision of Services to its optimum.
</li>
<li>
The right to data portability. Users have the right to be provided with a copy of the information We have on them in a structured, machine-readable and commonly used format.
</li>
<li>
The right to withdraw consent. Users have the right to withdraw their consent at any time where consent is given pertaining to Personal Information.
</li>
<li>
The right to be informed. Users have the right to be informed about third parties with which their information has been shared.
</li>
</ul>
Please note that Users may be asked to verify identity before responding to such requests. If the Users are unable to perform these actions themselves, please get in touch with the Grievance Officer for assistance.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>COOKIE POLICY:</h5>
A cookie is a small text file stored by a website in a User’s web browser that helps Us in many ways to make your use of the Services more efficient and meaningful to you (“Cookie(s)”). They allow Us to tailor the Service to better match your needs. A session Cookie is stored only in your computer’s working memory and only lasts for your browsing session. When You close all your browser’s windows, or when You shut down your computer, the session Cookie disappears forever. A persistent Cookie remains on your computer after You close your browser so that it can be used by your browser on subsequent visits to the Services. Persistent Cookies stay on your computer until either they expire or are overwritten with newer Cookies, or You manually remove them. Most browsers can be configured not to accept Cookies; however, this may prevent You from having access to some site functions or features.

The Cookies through which we collect data and How We use Cookies

Source	Purpose for which we collect data through Cookies
LocalStorage Cookies	To retain Site preferences (for example, UI settings) and example states.
Google Analytics	To understand what documentation pages are used and how to improve the Site.
YouTube	If video content is embedded, to understand video playback and improve content.

Apart from as mentioned above, We may use Cookies for the following purposes:
<ul>
    <li>
To provide and improve the Services;
</li>
<li>
To remember your preferences
</li>
<li>
For analytics and research, including to understand how You use the Services and which contents are preferred by You;
</li>
<li>
To personalize the Services for You; and
</li>
<li>
To assist with security and administrative functions.
</li>
</ul>
What are Your choices about Cookies?
You may learn more about how Cookies work and how to turn them off, in your particular browsers. Additionally, if you turn your Cookies off, some features of Our Services may not function properly.
</ListGroup.Item>

<ListGroup.Item style={{border:'None'}}>
<h5>CONTACT DETAILS:	</h5>		
Users may contact the Company by email or postal mail on the following address of the Grievance Officer:

<p>Company: Pixagan Technologies Private Limited</p>
<p>Grievance Officer: Anil Variyar </p>
<p>E-mail ID: pixagan@gmail.com	</p>
<p>Address: 39/2475-B1, Suite#244 </p>
<p> LR Towers, SJRRA 104, </p>
 <p>S Janatha Road, Palarivattom, </p>
<p>Kochi, Kerala, 682025 </p>
</ListGroup.Item>

</ListGroup>
        
        
        
        
        
        
        </div>


    )


}

export default PrivacyPolicyScreen


